import Masonry from "react-masonry-css";
import "./styles.css";
import projectList from "../Data/Projects";
import { useNavigate } from "react-router-dom";
import { projectImages } from "../utils/helpers";

function getGalleryImage(project) {
  // console.log("Getting gallery image for project:", project);
  // console.log(projectImages);
  const projectImgs = projectImages[project.id];
  if (!projectImgs) {
    console.warn(`No images found for project: ${project.id}`);
    return null;
  }
  // console.log("Project images:", projectImgs);
  const galleryImg = projectImgs.find((img) =>
    img.name.includes(project.galleryImageName),
  );
  if (!galleryImg) {
    console.warn(`No gallery image found for project: ${project.id}`);
    return null;
  }
  return galleryImg.src;
}

const breakpointColumnsObj = {
  default: 3,
  700: 2,
  500: 1,
};

export default function Gallery() {
  // useEffect(() => {
  //   imageList.forEach((image) => {
  //     preloadImage(image);
  //   });
  // }, []);

  const navigate = useNavigate();

  function handleClick(projectId) {
    navigate(`/proyectos/${projectId}`);
  }
  return (
    <Masonry
      breakpointCols={breakpointColumnsObj}
      className="my-masonry-grid"
      columnClassName="my-masonry-grid_column"
    >
      {Object.keys(projectList).map((projectId) => {
        const project = projectList[projectId]; // Assuming projectList is an object with projectId as keys
        if (!project || project["publish"] !== true) return null;
        return (
          <div
            key={projectId}
            onClick={() => {
              handleClick(projectId);
            }}
            className="gallery_slot"
          >
            <div>
              <img
                className="gallery_img"
                src={getGalleryImage(project)}
                alt={project.title}
              />
            </div>
            <strong className="gallery_img title">{project.title}</strong>
            <p className="gallery_img location">{project.location}</p>
          </div>
        );
      })}
    </Masonry>
  );
}
